import * as React from "react";

import { Card, Icon, Grid, Tag, Dimmer } from "tabler-react";
import ReactHtmlParser from "react-html-parser";
import textile from "textile-js";
import { FacebookShareButton, LinkedinShareButton } from "react-share";
import moment from "moment";

import withAuth from "../../utils/withAuth";
import { IJob } from "types/job";
import JobDetailsCTA from "./JobDetailsCTA.react";

export interface Props {
  jobDetails: IJob;
  isAuth: boolean;
  isApplied: boolean;
  applyJob: Function;
  openApplyModal: Function;
  openRegister: Function;
  openLogin: Function;
  isLoading: boolean;
}

class JobDetailsCard extends React.Component<Props> {
  render() {
    const { isLoading } = this.props;
    return (
      <React.Fragment>
        <Card className="job-details-card">
          <Card.Body className="job-card-body">
            <Card.Title className="mb-card">
              {this.props.jobDetails.title}
            </Card.Title>
            <p className="mb-card">
              {this.props.jobDetails.workspace
                ? this.props.jobDetails.workspace.name
                : ""}
            </p>
            <p className="mb-card">
              <Icon name="briefcase" />{" "}
              {`${
                (this.props &&
                  this.props.jobDetails &&
                  this.props.jobDetails.experience &&
                  this.props.jobDetails.experience.min) ||
                0
              }-${
                (this.props &&
                  this.props.jobDetails &&
                  this.props.jobDetails.experience &&
                  this.props.jobDetails.experience.max) ||
                0
              } Yrs`}
              <Icon name="map-pin" />
              {this.props.jobDetails.location}{" "}
            </p>

            <Tag.List>
              <Tag color="success" addOnIcon="activity">
                Full Time
              </Tag>
              <Tag color="dark" addOnIcon="book" addOnColor="primary">
                {this.props.jobDetails.functionalArea.secondary}
              </Tag>
            </Tag.List>
            <p className="social-share-wrapper">
              <FacebookShareButton
                hashtag={"#" + this.props.jobDetails.title}
                url={
                  "https://www.hirexl.in/job/" +
                  this.props.jobDetails.title.replace(/ /g, "-") +
                  "-" +
                  this.props.jobDetails.id
                }
              >
                <Icon prefix="fa" name="facebook" />
              </FacebookShareButton>
              {/* <GooglePlusShareButton
                url={
                  "https://www.hirexl.in/job/" +
                  this.props.jobDetails.title.replace(/ /g, "-") +
                  "-" +
                  this.props.jobDetails.id
                }
              >
                <Icon prefix="fa" name="google" />
              </GooglePlusShareButton> */}
              <LinkedinShareButton
                title={this.props.jobDetails.title}
                url={
                  "https://www.hirexl.in/job/" +
                  this.props.jobDetails.title.replace(/ /g, "-") +
                  "-" +
                  this.props.jobDetails.id
                }
              >
                <Icon prefix="fa" name="linkedin" />
              </LinkedinShareButton>
            </p>
          </Card.Body>
          <Card.Footer>
            <Grid.Row>
              <Grid.Col width={6}>
                <Icon name="calendar" />{" "}
                {moment(this.props.jobDetails.createdAt).fromNow()}
              </Grid.Col>
              <Grid.Col width={6} className="text-right">
                {/*  <img src="/static/images/rupee.png" alt="Rupee" width="10" />{" "}
              {`${this.props.jobDetails.salary.min}-${this.props.jobDetails.salary.max} LPA`} */}
              </Grid.Col>
            </Grid.Row>
          </Card.Footer>
        </Card>
        <Card>
          <Card.Body>
            <Grid.Row>
              <Grid.Col width={12}>Job Description</Grid.Col>
              <Grid.Col width={12} className="html-viewer">
                {ReactHtmlParser(textile(this.props.jobDetails.description))}
              </Grid.Col>
            </Grid.Row>
          </Card.Body>
          <Card.Footer>
            <Dimmer active={isLoading}>
              <JobDetailsCTA
                isLogged={this.props.isAuth}
                isApplied={this.props.isApplied}
                applyToJob={this.props.applyJob}
                openApplyModal={this.props.openApplyModal}
                openRegister={this.props.openRegister}
                openLogin={this.props.openLogin}
              />
            </Dimmer>
          </Card.Footer>
        </Card>
      </React.Fragment>
    );
  }
}

export default withAuth(JobDetailsCard);
